import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import Dropdown from "rc-dropdown";
import Menu, { MenuItem } from "rc-menu";
import "rc-dropdown/assets/index.css";

import { fetchProfile } from "../../actions/profile";

import { Link } from "react-router-dom/es";
import {
  changeAssetsSort,
  confirmationRequest,
  fetchCampaigns,
  fetchAssets,
  fetchPagedAssets,
  filterAssetsByAspect,
  filterAssetsByTag,
  filterAssetsByType,
  searchAssets,
  setPageTitle,
  switchAssetView,
  toggleFilterBar,
  updateAsset,
  uploadAsset,
  switchNormal,
  addFileToCampaignAction,
  addUserReport,
} from "signoxe/actions";
import { ASSETS_RESOURCE } from "signoxe/api/resources";
import {
  AssetDropzone,
  AssetTableView,
  AssetTileView,
  AssetResumable,
} from "signoxe/components";
import { Box, Page } from "signoxe/components/layout";
import {
  Button,
  FilterDropdown,
  Icon,
  Notification,
  Popup,
  SearchFilterBar,
  Switch,
} from "signoxe/components/widgets";
import {
  getAssetsSortBy,
  getAssetsSortDirection,
  getAssetsView,
  getFilterBarVisible,
  getFilterByAspect,
  getFilterByType,
  getFilteredAssetsByQuery,
  getTags,
  getProfile,
  getPreloadState,
  getFilteredAssetsByCampaign,
  assetSize,
  isFetchingAssests,
} from "signoxe/selectors";
import { searchStrFromRouterLocation } from "signoxe/utils/router";
import { DragDropContext } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import TouchBackend from "react-dnd-touch-backend";
import { Bars } from "react-loading-icons";

import "./styles.scss";

import Dropdown, {
  DropdownContent,
  DropdownTrigger,
} from "react-simple-dropdown";

import AssetModal from "../../components/AssetModal";
import {
  getCampaigns,
  getFilteredCampaigns,
  getFilteredCampaignsByQuery,
} from "signoxe/selectors/campaigns";

import { moveAssets } from "signoxe/actions";
import { fetchAssets } from "signoxe/actions";
import CampaignTileView from "signoxe/components/CampaignTileView";
import { escape } from "lodash";

const MAX = 1024 * 1024 * 30;

const assetStates = {
  ASSET: "asset",
  APP: "app",
  TEMPLATE: "template",
};

const PAGE_LIMIT = 100; // Controls the number of visible assets on the page till scroll event triggers

class AssetsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editMode: false,
      selection: {},
      togg:
        JSON.parse(localStorage.getItem("togg")) == undefined
          ? true
          : JSON.parse(localStorage.getItem("togg")),
      visible: false,
      btnVisible: false,
      assetType: assetStates.ASSET,
      isCampaignView: false,
      selectedCampaign: null,
      filteredCampaign: null,
      filterButton: null,
      loading: true,
      checkUnused: false,
      dataLimit: PAGE_LIMIT,
      selectHighlighted: false,
      showErrorMessage: false,
      selectedAllTogggled:false,
      reportActivityStatus:
        this.props.profile &&
        this.props.profile.features &&
        this.props.profile.features.record_user_activity,
    };
    this.handleCampaignView = this.handleCampaignView.bind(this);
    this.goToAssetsView = this.goToAssetsView.bind(this);
    this.removeAssetFromCampaign = this.removeAssetFromCampaign.bind(this);
    this.handleFilterBarToggle = this.handleFilterBarToggle.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.getTruncatedData = this.getTruncatedData.bind(this);
  }

  static propTypes = {
    // Data
    assets: PropTypes.array.isRequired,
    assetsView: PropTypes.string.isRequired,
    assetsSortBy: PropTypes.string.isRequired,
    assetsSortDirection: PropTypes.bool.isRequired,
    filterByType: PropTypes.string.isRequired,
    filterByAspect: PropTypes.string.isRequired,
    filterBarVisible: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired,
    searchString: PropTypes.string,
    // Functions
    addUserReport: PropTypes.func.isRequired,
    fetchCampaigns: PropTypes.func.isRequired,
    fetchAssets: PropTypes.func.isRequired,
    filterAssetsByType: PropTypes.func.isRequired,
    filterAssetsByTag: PropTypes.func.isRequired,
    filterAssetsByAspect: PropTypes.func.isRequired,
    uploadAsset: PropTypes.func.isRequired,
    updateAsset: PropTypes.func.isRequired,
    searchAssets: PropTypes.func.isRequired,
    switchAssetView: PropTypes.func.isRequired,
    setPageTitle: PropTypes.func.isRequired,
    confirmationRequest: PropTypes.func.isRequired,
    toggleFilterBar: PropTypes.func.isRequired,
    changeAssetsSort: PropTypes.func.isRequired,
    removeAssetFromCampaign: PropTypes.func.isRequired,
  };

  handleAssetClick = (asset) =>
    this.state.editMode
      ? this.handleAssetSelect(asset)
      : this.handleAssetPreview(asset);

  handleAssetDelete = (asset) => {
    const { profile } = this.props;
    if (
      this.props.profile &&
      this.props.profile.features &&
      this.props.profile.features.record_user_activity
    ) {
      this.props.addUserReport({
        user: profile.id,
        action_type: "Delete",
        activity: `deleted (or attempt to delete) playlist - ${asset.name}`,
      });
    }
    this.props.confirmationRequest(
      "Deleting Asset",
      `Deleting "${asset.name}" is a permanent action and will remove it from any playlists using it.`,
      "DELETE",
      ASSETS_RESOURCE,
      asset.id
    );
  };

  updateBtnVisibility = () => {
    this.setState({ btnVisible: !this.state.btnVisible });
  };

  updateAssetType = (type) => {
    this.setState({ assetType: type });
  };

  handleAssetPreview = (asset) => this.props.history.push(`/asset/${asset.id}`);

  handleAssetSelect = (asset) =>
    this.setState((prevState) => {
      const selection = prevState.selection;
      selection[asset.id] = !selection[asset.id];
      return { selection };
    });

  handleHighlightSelect = () => {
    console.log(this.state.selection);
    const selection = {};
    const { isCampaignView, selectedCampaign } = this.state;
    if (isCampaignView && selectedCampaign) {
      selectedCampaign &&
        selectedCampaign.assets.map((data) => {
          if (data.color < 1) {
            selection[data.id] = true;
          }
          this.setState({ selection: selection });
        });
    } else {
      this.props.assets.map((data) => {
        if (data.color < 1) {
          selection[data.id] = true;
        }
        this.setState({ selection: selection });
      });
    }
  };

  handleClearSelection = () =>
    this.setState({
      selection: {},
      selectedCampaign: null,
      isCampaignView: false,
      selectedAllTogggled:false,
    });

  handleDeleteSelected = () => {
    const { profile, assets } = this.props;
    const { selectedCampaign, isCampaignView } = this.state;

    if (
      this.props.profile &&
      this.props.profile.features &&
      this.props.profile.features.record_user_activity
    ) {
      const selectedAssetsIds = Object.keys(this.state.selection)
        .filter((assetId) => this.state.selection[assetId])
        .map((id) => parseInt(id));
      const selectedAssets = assets.filter((asset) =>
        selectedAssetsIds.includes(asset.id)
      );
      const arrayNames = selectedAssets.map((asset) => asset.name);
      const stringNames = arrayNames.join(", ");

      this.props.addUserReport({
        user: profile.id,
        action_type: "Delete",
        activity: `Bulk Delete or Bulk Delete Attempt  Assests - ${stringNames}`,
      });
    }
   

    if (isCampaignView && selectedCampaign) {
      this.props.confirmationRequest(
        "Deleting Multiple Assets",
        `Are you sure you want to delete all media from ${
          selectedCampaign && selectedCampaign.name
        } ?.`,
        "DELETE_MANY",
        ASSETS_RESOURCE,
        this.getSelectedAssets()
      );
    } else {
      console.log("getSelectedAssets", this.getSelectedAssets())
      this.props.confirmationRequest(
        "Deleting Multiple Assets",
        `Deleting assets is a permanent action and will remove the asset from any playlists using it.
       Note that that not all assets can be deleted. If your selection includes such an asset
       it will not be deleted.`,
        "DELETE_MANY",
        ASSETS_RESOURCE,
        this.getSelectedAssets()
      );
    }

    this.handleClearSelection();
  };

  increaseDataLimit = () => {
    this.setState({ dataLimit: this.state.dataLimit + PAGE_LIMIT });
  }

  getTruncatedData(data, dataLimit){
    return data.slice(0, dataLimit);
  }

  moveItem = (id) => {
    this.props.moveAssets(id, this.getSelectedAssets());
    this.handleClearSelection();
  };

  handleCheckUnused = () => {
    console.log("Handle un", this.state.checkUnused);
    this.setState({ checkUnused: !this.state.checkUnused });
  };

  handleFilter = (filterOn, filter) => {
    if (filterOn === "TYPE") {
      this.props.filterAssetsByType(filter);
    } else if (filterOn === "ASPECT") {
      this.props.filterAssetsByAspect(filter);
    } else if (filterOn === "TAGS") {
      this.props.filterAssetsByTag(filter);
    }
  };

  handleFilterBarToggle = () => {
    this.setState({ btnVisible: !this.state.btnVisible });
    this.filterButton.click();
  };

  handleSearch = (query) =>
    this.props.history.replace({
      search: `?search=${query}`,
    });

  handleSelectAll = () => {
    
    const { selectedCampaign, isCampaignView } = this.state;
    this.setState({ selectedAllTogggled: true})
    if (selectedCampaign && isCampaignView) {
      const selection = {};
      this.state.selectedCampaign &&
        this.state.selectedCampaign.assets.forEach(
          (asset) => (selection[asset.id] = true)
        );
      this.setState({ selection });
    } else {
      const selection = {};
      this.props.assets.forEach((asset) => (selection[asset.id] = true));
      this.setState({ selection });
    }
  };

  handleSwitchMode = () =>
    this.setState({ editMode: !this.state.editMode, selection: {} });

  onAssetChange = (newAsset) =>
    this.props.updateAsset(newAsset.id, { name: newAsset.name });

  uploadFiles = (files) => {
    const { isCampaignView, selectedCampaign } = this.state;
    console.log("isCampaignView", isCampaignView);
    console.log("selectedCampaign", selectedCampaign);

    console.log("uploading files now...");

    // if isCampaignView then upload to campaign
    this.props.switchNormal();
    files.forEach((file) =>
      this.props.uploadAsset(file, (selectedCampaign = selectedCampaign))
    );

    files.forEach((file) =>
      console.log("uploading asset for file", file)
    );

    const { profile } = this.props;
    if (
      this.props.profile &&
      this.props.profile.features &&
      this.props.profile.features.record_user_activity
    ) {
      files.forEach((file) =>
        this.props.addUserReport({
          user: profile.id,
          action_type: "Create",
          activity: `Uploaded Assest - ${file.name}`,
        })
      );
    }
  };

  toggleDrop() {
    this.setState({ togg: !this.state.togg });
    localStorage.setItem("togg", JSON.stringify(!this.state.togg));
  }

  handleScroll(){
    if (
      window.innerHeight + window.scrollY >= document.body.offsetHeight - 20 &&
      this.props.leafFiles && this.state.dataLimit < this.props.leafFiles.length
    ) {
      // Increase limit for dataset display
      this.increaseDataLimit();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  componentDidMount() {
    this.props.fetchProfile(true);
    this.props.setPageTitle("Assets");
    this.props.searchAssets(""); // Clear any existing search query
    if (this.props.assets) {
      this.setState({ loading: false });
    }

    window.addEventListener('scroll', this.handleScroll, true);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { isCampaignView, selectedCampaign, filteredCampaign } = this.state;
    if (prevProps.isFetching !== this.props.isFetching) {
      if (this.props.isFetching) {
        this.props.fetchCampaigns();
      }
    }
    if (prevProps.searchString !== this.props.searchString) {
      if (isCampaignView) {
        let fitleredCampaignAssets = selectedCampaign.assets.filter((asset) =>
          asset.name.toLowerCase().includes(this.props.searchString)
        );

        this.setState({
          filteredCampaign: {
            ...filteredCampaign,
            ["assets"]: fitleredCampaignAssets,
          },
        });
      }
    }

    if (
      prevProps.filterByType !== this.props.filterByType &&
      prevProps.filterByType !== null &&
      isCampaignView
    ) {
      console.log("Filter Type changed  ", this.props.filterByType);
      let fitleredCampaignAssets = selectedCampaign.assets.filter(
        (asset) =>
          this.props.filterByType === null ||
          asset.type.toLowerCase() === this.props.filterByType
      );
      this.setState({
        filteredCampaign: {
          ...filteredCampaign,
          ["assets"]: fitleredCampaignAssets,
        },
      });
    }

    if (
      prevProps.filterByAspect !== this.props.filterByAspect &&
      isCampaignView
    ) {
      console.log("Aspect Changed to ", this.props.filterByAspect);
      let campaignAssets = selectedCampaign.assets;
      console.log("campaignAssets =  ", campaignAssets);
      let filteredAssets = campaignAssets.filter((asset) => {
        let size = null;
        if (asset.type === "IMAGE" && asset.metadata && asset.metadata.File) {
          size = {
            width: asset.metadata.File.Width,
            height: asset.metadata.File.Height,
          };
        }
        if (
          asset.type === "IMAGE" &&
          asset.metadata &&
          asset.metadata.video_streams &&
          asset.metadata.video_streams
        ) {
          let videoData = asset.metadata.video_streams["0"];
          size = {
            width: videoData.Width,
            height: videoData.Height,
          };
        }
        console.log("size = ", size);
        if (size) {
          const ratio = size.width / size.height;
          return (
            (this.props.filterByAspect === "PORTRAIT" && ratio <= 1) ||
            (this.props.filterByAspect === "LANDSCAPE" && ratio >= 1)
          );
        } else return false;
      });

      console.log("Filtered Assets = ", filteredAssets);

      this.setState({
        filteredCampaign: {
          ...filteredCampaign,
          ["assets"]: filteredAssets,
        },
      });
    }
  }

  getSelectedAssets() {
    return Object.keys(this.state.selection).filter(
      (assetId) => this.state.selection[assetId]
    );
  }
  getSelectedCampaignAssets() {
    const { selectedCampaign } = this.state;
    return Object.keys(
      selectedCampaign && this.state.selectedCampaign.assets
    ).filter(
      (assetId) =>
        selectedCampaign &&
        this.state.selectedCampaign.assets &&
        this.state.selectedCampaign.assets[assetId]
    );
  }

  getSelectionCount() {
    return this.getSelectedAssets().length;
  }

  getSelectedCampaignAssetsCount() {
    const { selectedCampaign, selection } = this.state;
    if (selectedCampaign && selection) {
      return this.getSelectedCampaignAssets().length;
    }
    return 0;
  }

  getAllowedMime() {
    const { profile } = this.props;
    let data =
      profile &&
      profile.profile.package &&
      profile.profile.package.assets_types;

    let mimeTypes =
      data &&
      data
        .filter((type) => type.published === true)
        .map((type) => type.file_format)
        .join(", ");

    let mimes = mimeTypes && mimeTypes.toLowerCase();

    return mimes;
  }

  getUploadInstruction() {
    if (
      this.props.profile &&
      this.props.profile.features &&
      this.props.profile.features.office_files
    ) {
      return "Drop image, video, audio, PDF, or Office files here to upload or click to browse files.";
    }
    return "Drop image, video, audio or PDF files here to upload or click to browse files.";
  }

  getInstructionsResumable() {
    return `
    For Files larger than 30MB, Drop here to upload or click to browse files.
    `;
  }

  handleAssetDrop = (asset, campaignId) => {
    this.props.updateAsset(asset.id, {
      name: asset.name,
      campaign: campaignId,
    });
    // this.props.addFileToCampaignAction({ name: folder, assetId: asset.id });
    //console.log("Handle Asset Drop asset + campaignId= ", asset, campaignId);
  };
  handleDropRejected = (file, rejectedFiles) => {
    const max_uploadable_asset_size = localStorage.getItem(
      "max_uploadable_asset_size"
    );
    console.log("DROP REJECTED");
    console.log(file);
    const errorMessage = `${file.name} is too large, maximum file size is ${max_uploadable_asset_size} bytes`;
    // alert(errorMessage);
    this.setState({ showErrorMessage: !this.state.showErrorMessage });
  };

  handleCampaignView(campaign) {
    this.setState({
      selectedCampaign: campaign,
      filteredCampaign: campaign,
      isCampaignView: true,
    });
    //console.log("handleCampaignView campaign = ", campaign);
  }
  getProgressbarValue = () => {
    const { profile } = this.props;
    let loadedSize = this.getProfileStorage();
    let totalSize = profile && profile.max_storage_size;
    const percentage = (loadedSize / totalSize) * 100;
    const formattedPercentage = percentage.toFixed(2);
    return formattedPercentage;
  };

  getProfileStorage = () => {
    const { profile } = this.props;
    let loadedSize = profile && profile.profile && profile.profile.storage;
    if(typeof(loadedSize) == "number"){
      loadedSize = loadedSize / 1024 / 1024;
      return loadedSize.toFixed(2);
    }

    return loadedSize;
  }

  goToAssetsView() {
    this.setState({
      selectedCampaign: null,
      isCampaignView: false,
    });
  }

  removeAssetFromCampaign(asset, campaign) {
    console.log("removeAssetFromCampaign asset + campaign= ", asset, campaign);
    this.props.updateAsset(asset.id, {
      name: asset.name,
      campaign: null,
    });
  }
  onCancel = () => {
    this.setState({ showErrorMessage: !this.state.showErrorMessage });
  };

  render() {
    const { isCampaignView, selectedCampaign, selectedAllTogggled } = this.state;
    const selectionCount = this.getSelectionCount();
    const selectedCampaignAssetsCount = this.getSelectedCampaignAssetsCount();
    const isTileView = this.props.assetsView === "TILE";
    const isListView = this.props.assetsView === "LIST";
    const sortedByName = this.props.assetsSortBy === "NAME";
    const sortedByType = this.props.assetsSortBy === "TYPE";
    const sortedById = this.props.assetsSortBy === "ID";
    const isMakerChecker =
      this.props.profile && this.props.profile.maker_checker;
    const IsSelectedCampaignAssets = selectedCampaign && selectedAllTogggled

    console.log("isCampaignView", isCampaignView);
    console.log("selectedCampaign", selectedCampaign);

    const profile = this.props.profile;
    const allowed_pages = profile && this.props.profile.allowed_pages;
    const isNotAllowed =
      profile && allowed_pages && this.props.profile.allowed_pages.assets_page;

    const sortIcon = (
      <Icon
        name={this.props.assetsSortDirection ? "sort-desc" : "sort-asc"}
        margin={0}
        size="1em"
        color="white"
      />
    );

    const { togg, selectedCampaign, loading } = this.state;
    const { profile } = this.props;

    const max_uploadable_asset_size = localStorage.getItem(
      "max_uploadable_asset_size"
    );
    if (max_uploadable_asset_size < 0) {
      const file_size_message = <p>You can upload files of any size.</p>;
    } else {
      const file_size_message = (
        <p>
          Allowed Sizes: Up to {max_uploadable_asset_size}MB for Images/Videos &
          Up to 10MB for documents.
          <b>
            <i> Switch on "Resumable Upload" </i>
          </b>
          <br />
          to upload large video files.
        </p>
      );
    }
    return (
      <Page isNotAllowed={isNotAllowed} className="assets-page">
        {loading ? (
          <Box alignItems="center" justifyContent="center" className="">
            <div className="loading"></div>
          </Box>
        ) : null}
        {this.state.showErrorMessage ? (
          <Popup className="text-center" title="Assest Uploading Error" modal>
            <p className="pad-1">
              {max_uploadable_asset_size == -1
                ? "File not supported "
                : `File too large or format not supported, maximum file size is ${max_uploadable_asset_size} `}
              for this account Please contact your administrator.
            </p>
            <div className="pad-1 text-center pb flex flex-jc-sb">
              <div></div>
              <button className="button" onClick={this.onCancel}>
                Close{" "}
              </button>
            </div>
          </Popup>
        ) : null}
        {!loading && (
          <div>
            {togg ? (
              <AssetDropzone
                handleDropRejected={this.handleDropRejected}
                onDrop={this.uploadFiles}
                accept={this.getAllowedMime()}
                instruction={this.getUploadInstruction()}
                MAX_Size={
                  max_uploadable_asset_size < 0
                    ? "Infinity"
                    : 1024 * 1024 * max_uploadable_asset_size
                }
                file_size_message={file_size_message}
              />
            ) : (
              <AssetResumable
                accept={this.getAllowedMime()}
                instruction={this.getInstructionsResumable()}
              />
            )}
            <Box
              direction="row"
              alignItems="center"
              className="resumable small"
            >
              <Box direction="column" className="search-filter-bar">
                <Box direction="row" className="search-bar">
                  <FilterDropdown
                    isActive={this.props.filterBarVisible}
                    isListView={isListView}
                    isTileView={isTileView}
                    sortedByName={sortedByName}
                    sortedByType={sortedByType}
                    sortedById={sortedById}
                    assetsSortDirection={this.props.assetsSortDirection}
                    switchAssetView={this.props.switchAssetView}
                    togg={togg}
                    onFilterChange={this.handleFilter}
                    filterByType={this.props.filterByType}
                    filterByAspect={this.props.filterByAspect}
                    filterBarVisible={this.props.filterBarVisible}
                    tags={this.props.tags}
                    changeAssetsSort={this.props.changeAssetsSort}
                    onToggle={this.toggleDrop.bind(this)}
                  />

                  <SearchFilterBar
                    filterByType={this.props.filterByType}
                    filterByAspect={this.props.filterByAspect}
                    filterBarVisible={this.props.filterBarVisible}
                    tags={this.props.tags}
                    queryString={this.props.searchString}
                    onQueryChange={this.handleSearch}
                    onFilterChange={this.handleFilter}
                    onToggleFilterBar={this.handleFilterBarToggle}
                    togg={togg}
                    resumClick={this.toggleDrop.bind(this)}
                    toggleFilter={this.updateBtnVisibility.bind(this)}
                  />

                  <div
                    style={{ marginLeft: "10px", marginBottom: "0px" }}
                    onClick={this.toggleDrop.bind(this)}
                    className="editMode__button"
                  >
                    {this.getProgressbarValue() < 74 ? (
                      <Button onClick={this.handleSwitchMode}>
                        {this.state.editMode ? "Leave Edit Mode" : "Edit Mode"}
                      </Button>
                    ) : (
                      <Button
                        onClick={this.handleSwitchMode}
                        className="progress-storage-full"
                      >
                        {this.state.editMode ? "Exit" : "Manage Assets"}
                      </Button>
                    )}
                  </div>
                </Box>
              </Box>
            </Box>

            <Box direction="row" justifyContent="flex-start">
              {this.state.btnVisible ? (
                <Box
                  direction="row"
                  justifyContent="space-between"
                  className="w-100"
                >
                  <Dropdown>
                    <DropdownTrigger>
                      <button className="button filter-btn">
                        <span style={{ marginRight: "5px" }}>
                          <Icon
                            name="settings"
                            margin={0}
                            size="1em"
                            color="white"
                          />
                        </span>
                      </button>
                    </DropdownTrigger>
                    <DropdownContent className="filter-menu card depth-2">
                      <li>
                        <Box
                          direction="row"
                          alignItems="center"
                          className="button-group small"
                          wrap
                        >
                          <Box direction="row" className="label-bx">
                            <span className="label secondary">View as:</span>
                          </Box>
                          <Button
                            className={classNames({ hollow: !isListView })}
                            onClick={() => this.props.switchAssetView("LIST")}
                          >
                            List
                          </Button>
                          <Button
                            className={classNames({ hollow: !isTileView })}
                            onClick={() => this.props.switchAssetView("TILE")}
                          >
                            Tiles
                          </Button>
                        </Box>
                      </li>
                      <li>
                        <Box
                          direction="row"
                          alignItems="center"
                          className="button-group small"
                          wrap
                        >
                          <Box direction="row" className="label-bx">
                            <span className="label secondary">Sort by:</span>
                          </Box>
                          <Button
                            className={classNames({ hollow: !sortedByName })}
                            onClick={() => this.props.changeAssetsSort("NAME")}
                          >
                            {sortedByName && sortIcon} Name
                          </Button>
                          <Button
                            className={classNames({ hollow: !sortedByType })}
                            onClick={() => this.props.changeAssetsSort("TYPE")}
                          >
                            {sortedByType && sortIcon} Type
                          </Button>
                          <Button
                            className={classNames({ hollow: !sortedById })}
                            onClick={() => this.props.changeAssetsSort("ID")}
                          >
                            {sortedById && sortIcon} Time
                          </Button>
                        </Box>
                      </li>

                      <li>
                        <Box
                          direction="row"
                          alignItems="center"
                          className="button-group small"
                          wrap
                        >
                          <Box direction="row" className="label-bx">
                            <span className="label secondary">
                              Resummable Upload :{" "}
                            </span>
                          </Box>

                          <Switch checked={!togg} />
                        </Box>
                      </li>
                    </DropdownContent>
                  </Dropdown>
                </Box>
              ) : null}
              <AssetModal
                history={this.props.history}
                disable={() => this.setState({ visible: false })}
                visible={this.state.visible}
              />
            </Box>
            {/* {this.props.isFetching && (
          <div className="notificationBox">
            <Notification message="Action is being processed . please wait..." />
          </div>
        )} */}

            <Box
              direction="row"
              alignItems="center"
              className="action-bar wrap-for-small"
              wrap
            >
              <div className="flex-spacer" />
              <Box direction="row" className="button-group small">
                {isCampaignView && (
                  <Button onClick={this.goToAssetsView}>Go Back</Button>
                )}
              </Box>
            </Box>
            {this.state.editMode && (
              <Box
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                className="button-group"
                wrap
              >
                <div style={{ flexGrow: 1 }}>
                  Selected:{" "}
                  {IsSelectedCampaignAssets
                    ? selectedCampaignAssetsCount
                    : selectionCount || "none"}
                </div>
                <Button onClick={this.handleCheckUnused}>
                  {this.state.checkUnused
                    ? "Clear Highlight"
                    : "Highlight Unused"}
                </Button>

                <Button
                  onClick={this.handleHighlightSelect}
                  isDisabled={!this.state.checkUnused}
                >
                  Select Highlighted
                </Button>
                <Dropdown
                  trigger={["click"]}
                  overlay={
                    <Menu style={{ padding: "5px", fontSize: "15px" }}>
                      <button key={-1} disabled>
                        Move items(s) to one of the folders below:
                      </button>
                      {this.props.campaigns.length > 0
                        ? this.props.campaigns.map((data, index) => (
                            <MenuItem
                              style={{ cursor: "pointer" }}
                              key={index}
                              onClick={() => this.moveItem(data.id)}
                            >
                              {data.name}
                            </MenuItem>
                          ))
                        : "No folders"}
                    </Menu>
                  }
                  animation="slide-up"
                  alignPoint
                >
                  <Button isDisabled={selectionCount === 0}>
                    Move Selected
                  </Button>
                </Dropdown>

                <Button
                  className="alert"
                  onClick={
                    selectionCount === 0 ? null : this.handleDeleteSelected
                  }
                >
                  Delete Selected
                </Button>
                <Button onClick={this.handleSelectAll}>Select All</Button>
                <Button
                  onClick={
                    selectionCount === 0 ? null : this.handleClearSelection
                  }
                >
                  Clear Selection
                </Button>
              </Box>
            )}

            {this.getProgressbarValue() > 0 && (
              <div>
                <div className="flex">
                  <p className="text-p-bar">
                    {" "}
                    {profile &&
                      profile.profile &&
                      this.getProfileStorage()}{" "}
                    of {profile && profile.max_storage_size} MB
                  </p>
                </div>
                <div className="progress-bar-2">
                  <div
                    className={`progress-2 ${
                      this.getProgressbarValue() > 74
                        ? "progress-storage-full"
                        : "progress-storage-ok"
                    }`}
                    style={{ width: `${this.getProgressbarValue()}%` }}
                  ></div>
                </div>
              </div>
            )}

            {isTileView && (
              <AssetTileView
                isMakerChecker={isMakerChecker}
                assets={this.getTruncatedData(this.props.leafFiles, this.state.dataLimit)}
                selection={this.state.selection}
                onAssetClick={this.handleAssetClick}
                onAssetChange={this.onAssetChange}
                onAssetDelete={this.handleAssetDelete}
                onDrop={this.handleAssetDrop}
                onView={this.handleCampaignView}
                isCampaignView={this.state.isCampaignView}
                campaign={selectedCampaign}
                selectedCampaign={this.state.filteredCampaign}
                onRemove={this.removeAssetFromCampaign}
                campaigns={this.props.filteredCampaigns}
                checkUnused={this.state.checkUnused}
              />
            )}

            {isListView && (
              <AssetTableView
                assets={this.getTruncatedData(this.props.assets, this.state.dataLimit)}
                selection={this.state.selection}
                onAssetClick={this.handleAssetClick}
                onAssetChange={this.onAssetChange}
                onAssetDelete={this.handleAssetDelete}
              />
            )}
          </div>
        )}
      </Page>
    );
  }
}

export default connect(
  (state, props) => {
    const searchString = searchStrFromRouterLocation(props.location);

    return {
      searchString,

      assets: getFilteredAssetsByQuery(state, searchString),
      leafFiles: getFilteredAssetsByCampaign(state, searchString),
      campaigns: getCampaigns(state, searchString),
      filteredCampaigns: getFilteredCampaignsByQuery(state, searchString),
      assetsView: getAssetsView(state),
      assetsSortBy: getAssetsSortBy(state),
      assetsSortDirection: getAssetsSortDirection(state),
      tags: getTags(state),
      filterByType: getFilterByType(state),
      filterByAspect: getFilterByAspect(state),
      filterBarVisible: getFilterBarVisible(state),
      profile: getProfile(state),
      next: getPreloadState(state),
      isFetching: state.assets.isFetching,
    };
  },
  {
    fetchCampaigns,
    fetchAssets,
    fetchPagedAssets,
    filterAssetsByType,
    filterAssetsByTag,
    filterAssetsByAspect,
    uploadAsset,
    updateAsset,
    confirmationRequest,
    searchAssets,
    setPageTitle,
    toggleFilterBar,
    switchAssetView,
    changeAssetsSort,
    switchNormal,
    addFileToCampaignAction,
    moveAssets,
    fetchProfile,
    addUserReport,
  }
)(AssetsPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/AssetsPage/index.js